import { Component, OnInit, Injectable } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router, CanActivate, ActivatedRouteSnapshot,RouterStateSnapshot } from '@angular/router';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css']
})
@Injectable()
export class SignInComponent implements OnInit {
  isLoginError : boolean = false;
  constructor(private userService : UserService, private router : Router) { }

  ngOnInit() {
  }

//  OnSubmit(userName,password){
//     this.userService.userAuthentication(userName,password).subscribe((data : any)=>
//    {
//     // localStorage.setItem('userToken',data.access_token);
//      this.router.navigate(['/Dashboard']);
//    },
//    (err : HttpErrorResponse)=>{
//      this.isLoginError = true;
//    });
//  }

 OnSubmit(userName: string, password: string){
    // this.userService.userAuthentication(userName,password).subscribe((data : any)=>
    if (userName == "shady" && password == "admin")
    {
     // localStorage.setItem('userToken',data.access_token);
     
      this.router.navigate(['/articles']);
    } 
    else{
    }
    (err : HttpErrorResponse)=>{
      this.isLoginError = true;
    };
  }

}
